import { isNilOrEmpty } from 'utils/helpers';
import { pipe, values, flatten, difference, reject } from 'ramda';
export var calculateTeamTicketTypesInitialValues = function (data) {
    var _a;
    var types = (_a = data === null || data === void 0 ? void 0 : data.team) === null || _a === void 0 ? void 0 : _a.ticket_types;
    if (isNilOrEmpty(types))
        return {};
    return types.reduce(function (acc, currentItem) {
        var itemId = currentItem.id, group = currentItem.group;
        var groupId = group.id;
        if (!acc[groupId])
            acc[groupId] = [];
        acc[groupId].push(itemId);
        return acc;
    }, {});
};
export var calculateTeamDeliverablesInitialValues = function (data) {
    var _a;
    var deliverables = (_a = data === null || data === void 0 ? void 0 : data.team) === null || _a === void 0 ? void 0 : _a.deliverables;
    if (isNilOrEmpty(deliverables))
        return {};
    return deliverables.reduce(function (acc, currentItem) {
        var itemId = currentItem.id, group_position = currentItem.group_position;
        if (!acc[group_position])
            acc[group_position] = [];
        acc[group_position].push(itemId);
        return acc;
    }, {});
};
export var calculateFlatChanges = function (initial, submitted) {
    var allInitialIds = pipe(values, flatten)(initial);
    var allSubmittedIds = pipe(values, flatten)(submitted);
    var added = difference(allSubmittedIds, allInitialIds);
    var removed = difference(allInitialIds, allSubmittedIds);
    return {
        add_ids: reject(isNilOrEmpty, added),
        remove_ids: reject(isNilOrEmpty, removed)
    };
};
export var calculateFlagChanges = function (initial, submitted) {
    if (initial === void 0) { initial = []; }
    if (submitted === void 0) { submitted = []; }
    var added = submitted.filter(function (id) { return !initial.includes(id); });
    var removed = initial.filter(function (id) { return !submitted.includes(id); });
    var totalChangesCount = added.length + removed.length;
    return { add_ids: added, remove_ids: removed, totalChangesCount: totalChangesCount };
};
